import { Box, styled, IconButton } from "@mui/material";

export const Styled = {
    Container: styled(Box)`
        width: 100%;
        height: 100%;
        max-width: 100%;
        min-height: 0;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        padding-bottom: 8px;

        .super-app-theme--header {
            background-color: #009ac8;
            color: white;
            .MuiDataGrid-sortIcon {
                color: white;
            }
        }
        .MuiDataGrid-cell {
            color: #000000;
            border-bottom: 1px solid #d7dde4;
        }
        .MuiDataGrid-row:nth-of-type(odd) {
            background-color: #f9f9f9;
        }
        .MuiDataGrid-main {
            background: #ffffff;
            overflow: hidden;
        }
        .MuiDataGrid-columnHeaders {
            min-height: 46px !important;
            max-height: 46px !important;
        }
        .MuiDataGrid-columnHeaderTitle {
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0.1px;
        }
        .MuiDataGrid-cell {
            font-size: 15px;
            padding: 0 12px;
            display: flex;
            align-items: center;
        }
        .MuiDataGrid-virtualScroller {
            overflow: auto;
        }
        .MuiDataGrid-footerContainer {
            background-color: #009ac8;
            color: white;
            padding-right: 14px;

            .MuiTablePagination-toolbar {
                min-height: 44px;
                gap: 10px;
            }

            .MuiTablePagination-root,
            .MuiTablePagination-selectLabel,
            .MuiTablePagination-displayedRows,
            .MuiTablePagination-actions,
            .MuiSvgIcon-root {
                color: white;
            }

            .MuiTablePagination-displayedRows {
                margin-right: 6px;
                padding-right: 8px;
                border-right: 1px solid rgba(255, 255, 255, 0.35);
            }

            .MuiSelect-icon {
                color: white;
            }

            .MuiTablePagination-actions {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-left: 10px;
                margin-right: 8px;
            }

            .MuiTablePagination-actions button {
                color: #ffffff !important;
                padding: 5px !important;
                border-radius: 8px !important;
                border: 1px solid rgba(255, 255, 255, 0.35) !important;
            }

            .MuiTablePagination-actions button:not(.Mui-disabled) {
                background-color: rgba(255, 255, 255, 0.18) !important;
            }

            .MuiTablePagination-actions button:hover:not(.Mui-disabled) {
                background-color: rgba(255, 255, 255, 0.3) !important;
            }

            .MuiTablePagination-actions button.Mui-disabled {
                color: rgba(255, 255, 255, 0.45) !important;
                border-color: rgba(255, 255, 255, 0.2) !important;
                background-color: transparent !important;
            }

            .MuiTablePagination-actions button .MuiSvgIcon-root {
                font-size: 20px !important;
            }
        }

        .MuiDataGrid-cell:focus,
        .MuiDataGrid-cell:focus-within,
        .MuiDataGrid-cell--editing,
        .MuiDataGrid-row--selected {
            outline: none !important;
        }

        @keyframes spin {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        }
    `,

    Header: styled(Box)`
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        padding: 12px 24px;
        background: #ffffff;
    `,
    GridWrapper: styled(Box)`
        flex: 1;
        min-height: 0;
        max-width: 100%;
        padding: 0;
        overflow: hidden;
        .MuiDataGrid-root {
            height: 100%;
            width: 100%;
            max-width: 100%;
            border: none;
            border-radius: 0;
        }
    `,
    SearchContainer: styled(Box)`
        width: min(340px, 40vw);
    `,
    IconButton: styled(IconButton)`
        background-color: transparent;
        padding: 0;

        &:hover {
            background-color: transparent;
        }
    `,
    SpinningIcon: styled(Box)`
        display: inline-flex;
        animation: ${({ loading }: { loading: number }) =>
            loading ? "spin 1s linear infinite" : "none"};
    `,
};
